module.exports = new __parcel__URL__("layers.760a0456.png").toString();